import { render, staticRenderFns } from "./AdminUserForm.vue?vue&type=template&id=521f31dd"
import script from "./AdminUserForm.vue?vue&type=script&lang=ts"
export * from "./AdminUserForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminUserForm.vue?vue&type=style&index=0&id=521f31dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports